export const DATASETS = {
  BLOCKED_PAGE_LOADS: "blockedPageloads",
  BLOCKED_SITE_INTERACTIONS: "blockedSiteInteractions"
}